import { createSlice } from "@reduxjs/toolkit";

/**
 * current error state
 * event: the sdk event that registered the error (ex: "SDK_ERROR")
 * type: the error type returned by the sdk (ex: "CAMERA_UNKNOWN_DEVICE_ISSUE")
 */
export const errorSlice = createSlice({
  name: "error",
  initialState: {
    value: { event: false, type: false },
  },
  reducers: {
    update: (state, action) => {
      state.value.event = action.payload.event;
      state.value.type = action.payload.type;
    },
    clear: (state) => {
      state.value.event = false;
      state.value.type = false;
    },
  },
});

export const { update, clear } = errorSlice.actions;

export default errorSlice.reducer;
